import React, { useState } from "react";
import { useFormik } from "formik";
import FormWrapper from "components/common/formWrapper/FormWrapper";
import "components/common/parentButton/parentbtn.scss";
import { login } from "services/UserManagementServices";
import { Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { fetchProfile } from "services/FetchProfile";
import { useAuth } from "hooks/authentication/useAuth";
import { usePermission } from "hooks/permission/usePermission";
import { productId } from "common/constants/constants";
import { useTranslation } from "react-i18next";
import { toast } from "react-hot-toast";
const LoginForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const auth = useAuth();
  const { setPermissions } = usePermission();

  const fetchUserProfile = async () => {
    const { route } = await fetchProfile(auth, setPermissions);
    if (route) navigate(route);
  };
  const handleSubmit = async (data) => {
    setLoading(true);
    data = { ...data, productId: productId };
    const result = await login(data);
    if (result?.success) {
      localStorage.setItem("userExists", true);
      fetchUserProfile();
    } else if (result.status === 422) {
      formik.setErrors({ apiError: t("login-error") });
    } else {
      formik.setErrors({ apiError: t("no-permission-message") });
      toast.error(t("no-permission-message"));
    }
    setLoading(false);
  };
  const validate = Yup.object({
    email: Yup.string().email("Invalid Email Address").required(t("required")),
    password: Yup.string().required(t("required")),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      apiError: "",
    },
    onSubmit: (values) => {
      handleSubmit(values);
    },
    validationSchema: validate,
  });

  const errorStyle = {
    color: "red",
    marginBottom: "0",
    textAlign: "start",
  };
  return (
    <FormWrapper heading={t("login")}>
      <div style={{ maxWidth: "500px" }}>
        <form
          onSubmit={formik.handleSubmit}
          className="d-flex flex-column justify-content-center "
        >
          <p className="mt-5"> {t("enter-email-password")}</p>

          <div className="inputField  mt-4">
            <input
              type="email"
              className="form-control"
              placeholder={t("email-address")}
              name="email"
              onChange={formik.handleChange}
              value={formik.values.email}
            />
            {formik.errors.email && formik.touched.email && (
              <p style={errorStyle}>{formik.errors.email}</p>
            )}
          </div>
          <div className="inputField  mt-2">
            <input
              type="password"
              className="form-control"
              placeholder="**********"
              name="password"
              onChange={formik.handleChange}
              value={formik.values.password}
            />
            {formik.errors.password && formik.touched.password && (
              <p style={errorStyle}>{formik.errors.password}</p>
            )}
          </div>
          {formik.errors.apiError && (
            <p style={errorStyle}>{formik.errors.apiError}</p>
          )}

          <Link
            to="/forget-password"
            style={{
              textDecoration: "none",
              textAlign: "left",
            }}
          >
            {t("forgot-password")}
          </Link>
          <button className="parentbtn mt-4" type="submit">
            {loading ? <Spinner size="sm" animation="border" /> : t("login")}
          </button>
        </form>
      </div>
    </FormWrapper>
  );
};

export default LoginForm;
